module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.item) ? _c('div', {
    staticClass: "asset-management-action-buttons"
  }, [_c('div', {
    staticClass: "button-group small"
  }, [_c('swap-asset', {
    attrs: {
      "item": _vm.item
    },
    on: {
      "processSwap": _vm.processSwap
    }
  }), _c('move-asset', {
    attrs: {
      "item": _vm.item
    },
    on: {
      "assetMoved": _vm.assetMoved
    }
  }), _c('router-link', {
    staticClass: "button button-small warning",
    attrs: {
      "to": {
        name: 'operations',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_vm._v("Drain")]), _c('div', {
    staticClass: "button alert small alert-text",
    on: {
      "click": _vm.dismiss
    }
  }, [_vm._v("Dismiss")])], 1)]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-add47898!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/structure/ui/actions/AssetManagementActionButtons.vue
// module id = 2662
// module chunks = 1